// styles
import styles from '../styles/ProgressBar.module.css';

interface ProgressBarProps {
  activeStep: number;
  setActiveStep: (step: number) => void;
  setEntryOptionSelected?: (entryOptionSelected: boolean) => void;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  activeStep,
  setActiveStep,
  setEntryOptionSelected
}) => {

  const onMenuItemClick = (step: number) => {
    if(activeStep !== 1) return;
    setActiveStep(step);
    if(setEntryOptionSelected) {
      setEntryOptionSelected(false);
    }
  };

  return (
    <div>
      <div style={{paddingLeft: '23px', paddingRight: '29px'}} className={styles.iconContainer}>

      <div onClick={() => onMenuItemClick(0)} style={{cursor: activeStep === 1 ? 'pointer': ''}} className={styles.step}>
        <div style={{display: 'flex'}}>
          <div className={activeStep === 0 ? styles.iconActive : styles.iconInactive}>
            <svg style={{transform: 'scale(1.6'}} className={styles.icon} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M8.39568 17.032L11.8771 21.5773L14.0024 18.8025L16.1277 21.5773L18.253 18.8025L20.3783 21.5773L23.8598 17.032L23.8611 17.0302C25.0536 15.4616 25.0536 13.2888 23.8611 11.7202L23.8608 11.7197C23.0251 10.6215 21.7439 10 20.3783 10C19.6239 10 18.8951 10.1897 18.253 10.5448C17.611 10.1897 16.8822 10 16.1277 10C15.3733 10 14.6445 10.1897 14.0024 10.5448C13.3604 10.1897 12.6316 10 11.8771 10C10.5116 10 9.23038 10.6215 8.3947 11.7197L8.39434 11.7202C7.20189 13.2888 7.20189 15.4616 8.39434 17.0302L8.39568 17.032ZM15.0828 11.3906C15.1797 11.4949 15.2721 11.6047 15.3596 11.7197L15.3599 11.7202C16.5524 13.2888 16.5524 15.4616 15.3599 17.0302L15.3586 17.032L14.7686 17.8022L16.1277 19.5766L18.642 16.294C19.5037 15.1604 19.5037 13.59 18.642 12.4564C18.04 11.6653 17.1193 11.2165 16.1277 11.2165C15.766 11.2165 15.4137 11.2763 15.0828 11.3906ZM14.3914 16.294L11.8771 19.5766L9.36283 16.294C8.50112 15.1604 8.50112 13.59 9.36283 12.4564C9.96484 11.6653 10.8856 11.2165 11.8771 11.2165C12.8687 11.2165 13.7894 11.6653 14.3914 12.4564C15.2531 13.59 15.2531 15.1604 14.3914 16.294ZM20.3783 19.5766L19.0192 17.8022L19.6092 17.032L19.6105 17.0302C20.803 15.4616 20.803 13.2888 19.6105 11.7202L19.6102 11.7197C19.5227 11.6047 19.4303 11.4949 19.3334 11.3906C19.6643 11.2763 20.0166 11.2165 20.3783 11.2165C21.3699 11.2165 22.2906 11.6653 22.8926 12.4564C23.7544 13.59 23.7544 15.1604 22.8926 16.294L20.3783 19.5766Z"
                    fill={activeStep === 0 ? "#FFFFFF" : "var(--fow-accent-dark-color)"} />
              <rect x="11.8802" y="15.6023" width="1.45985" height="1.45985" transform="rotate(-135 11.8802 15.6023)"
                    fill={activeStep === 0 ? "#FFFFFF" : "var(--fow-accent-dark-color)"} />
            </svg>
          </div>
        </div>
      </div>

      <div className={styles.separator}/>

      <div className={styles.step}>
        <div style={{display: 'flex'}}>
          {/*<div className={styles.separatorLeft}/>*/}
          <div className={activeStep === 1 ? styles.iconActive : styles.iconInactive}>
            <svg className={styles.icon} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M8.99999 2.08031C5.17222 2.08031 2.07055 5.17911 2.07055 9.00002C2.07055 12.8209 5.17222 15.9197 8.99999 15.9197C12.8278 15.9197 15.9294 12.8209 15.9294 9.00002C15.9294 5.17911 12.8278 2.08031 8.99999 2.08031ZM0.854004 9.00002C0.854004 4.50575 4.50183 0.86377 8.99999 0.86377C13.4982 0.86377 17.146 4.50575 17.146 9.00002C17.146 13.4943 13.4982 17.1363 8.99999 17.1363C4.50183 17.1363 0.854004 13.4943 0.854004 9.00002Z"
                    fill={activeStep > 1 ? "var(--fow-accent-dark-color)" : activeStep === 1 ? "#FFFFFF" : "#999594CC"}/>
              <path d="M10.4064 6.8103H11.8662V8.27016H10.4064V6.8103Z"
                    fill={activeStep > 1 ? "var(--fow-accent-dark-color)" : activeStep === 1 ? "#FFFFFF" : "#999594CC"}/>
              <path d="M10.4064 9.72998H11.8662V11.1898H10.4064V9.72998Z"
                    fill={activeStep > 1 ? "var(--fow-accent-dark-color)" : activeStep === 1 ? "#FFFFFF" : "#999594CC"}/>
              <path d="M8.94652 8.27026H10.4064V9.73012H8.94652V8.27026Z"
                    fill={activeStep > 1 ? "var(--fow-accent-dark-color)" : activeStep === 1 ? "#FFFFFF" : "#999594CC"}/>
              <path d="M6.02684 6.8103H7.48669V8.27016H6.02684V6.8103Z"
                    fill={activeStep > 1 ? "var(--fow-accent-dark-color)" : activeStep === 1 ? "#FFFFFF" : "#999594CC"}/>
              <path d="M6.02684 9.72998H7.48669V11.1898H6.02684V9.72998Z"
                    fill={activeStep > 1 ? "var(--fow-accent-dark-color)" : activeStep === 1 ? "#FFFFFF" : "#999594CC"}/>
              <path d="M4.567 8.27026H6.02686V9.73012H4.567V8.27026Z"
                    fill={activeStep > 1 ? "var(--fow-accent-dark-color)" : activeStep === 1 ? "#FFFFFF" : "#999594CC"}/>
            </svg>
          </div>
        </div>
      </div>

      <div className={styles.separator}/>

      <div className={styles.step}>
        <div style={{display: 'flex'}}>
          {/*<div className={styles.separatorLeft}/>*/}
          <div className={activeStep === 2 ? styles.iconActive : styles.iconInactive}>
            <svg className={styles.icon} width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fillRule="evenodd" clipRule="evenodd" d="M2.66135 12.9841C5.36705 15.6898 9.66843 15.8273 12.5363 13.3965L15.9949 16.8551L16.8551 15.9949L13.3965 12.5363C15.8273 9.66843 15.6898 5.36704 12.9841 2.66134C10.1335 -0.189198 5.51189 -0.189198 2.66135 2.66134C-0.189198 5.51189 -0.189198 10.1335 2.66135 12.9841ZM12.1238 12.1238C9.74839 14.4993 5.89703 14.4993 3.52157 12.1238C1.14612 9.74839 1.14612 5.89702 3.52157 3.52157C5.89703 1.14612 9.74839 1.14612 12.1238 3.52157C14.4993 5.89702 14.4993 9.74839 12.1238 12.1238Z"
                    fill={activeStep === 2 ? "#FFFFFF" : "#999594CC"} fillOpacity="0.8"/>
              <path d="M18.5755 15.9949L17.7153 15.1346L16.8551 15.9949L17.7153 16.8551L18.5755 15.9949Z"
                    fill={activeStep === 2 ? "#FFFFFF" : "#999594CC"} fillOpacity="0.8"/>
              <path d="M17.7153 16.8551L16.8551 17.7153L17.7153 18.5755L18.5756 17.7153L17.7153 16.8551Z"
                    fill={activeStep === 2 ? "#FFFFFF" : "#999594CC"} fillOpacity="0.8"/>
            </svg>
          </div>
        </div>
      </div>
      </div>
      <div className={styles.container}>

        <div onClick={() => onMenuItemClick(0)} style={{cursor: activeStep === 1 ? 'pointer': ''}} className={styles.step}>
          <p className={`${styles.text} ${activeStep === 0 ? styles.textActive : ''}`}>Contribution</p>
        </div>

        <div className={styles.step}>
          <p className={`${styles.text} ${activeStep === 1 ? styles.textActive : activeStep < 1 ? styles.textInactive : ''}`}>Payment</p>
        </div>

        <div className={styles.step}>
          <p className={`${styles.text} ${activeStep === 2 ? styles.textActive : styles.textInactive}`}>Confirmation</p>
        </div>
      </div>
    </div>
  )
};

export default ProgressBar;
